import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Label, Radio } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

import { StyledFlexContainer } from './StyledComponents';
import { Spacer } from '@zillow/constellation';

const propTypes = {
  label: PropTypes.node.isRequired,
  description: PropTypes.node,
  helperText: PropTypes.node,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  radioExampleText: PropTypes.node,
};
const defaultProps = {
  description: null,
  helperText: null,
  checked: false,
  radioExampleText: null,
};

const RadioButton = ({
  label,
  description,
  helperText,
  checked,
  name,
  id,
  onClick,
  radioExampleText,
  tag,
  ...rest
}) => (
  <div>
    <StyledFlexContainer
      data-test={id}
      display="flex"
      justifyContent="center"
      flexDirection="column"
      paddingY="md"
      paddingX="sm"
      onClick={onClick}
      htmlFor={id}
      active={checked}
      marginBottom="xs"
      {...rest}
    >
      {tag ? <Spacer marginBottom="sm">{tag}</Spacer> : null}
      <Flex display="flex" flex="row" alignItems="center">
        <Radio name={name} id={id} checked={checked} marginRight="sm" readOnly={true} data-testid={`${id}-Radio`} />
        <div>
          <Label size="lg">{label}</Label>
          <Paragraph>{description}</Paragraph>
        </div>
      </Flex>
      {radioExampleText}
    </StyledFlexContainer>
    {helperText}
  </div>
);

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
